import { ValidationError } from "yup";

import { getNewAddressSchema, getUpdateAddressSchema } from "../models/address";
import type { TNewAddressForm } from "../types";

type TValidateReturn<T> = {
  isSuccess: boolean;
  errorDetails?: Partial<Record<keyof T, string>>;
};

const validateAddressForm = async <T>(form: Partial<TNewAddressForm>, isNew?: boolean): Promise<TValidateReturn<T>> => {
  const schema = isNew ? getNewAddressSchema() : getUpdateAddressSchema();
  try {
    await schema.validate(form, { abortEarly: false });
    return { isSuccess: true };
  } catch (error) {
    console.error("Address validation error", error);
    if (error instanceof ValidationError) {
      const errorDetails = {};
      error.inner?.forEach((fieldError) => {
        if (!fieldError.path) {
          return;
        }
        errorDetails[fieldError.path] = fieldError.message;
      });
      return { isSuccess: false, errorDetails };
    }
    return { isSuccess: false };
  }
};
export default validateAddressForm;
